import styles from "./TableRow.module.scss";

const TableRow = ({ children }) => {
  return <div className={styles.tableRow}>{children}</div>;
};
export default TableRow;
